export default {

  // 出入库
  // 新增客户出入库
  insertYgnInoutRecord: '/ygsjzs/ygnInoutRecord/insertYgnInoutRecord',
  // 修改客户出入库
  updateYgnInoutRecord: '/ygsjzs/ygnInoutRecord/updateYgnInoutRecord',
  // 审批客户出入库
  approveYgnInoutRecord: '/ygsjzs/ygnInoutRecord/approveYgnInoutRecord',
  // 物理删除客户出入库
  deleteDataYgnInoutRecord: '/ygsjzs/ygnInoutRecord/deleteDataYgnInoutRecord',

  // 查询客户出入库详情
  selectYgnInoutRecordByInventoryId: '/ygsjzs/ygnInoutRecord/selectYgnInoutRecordByInventoryId',
  // 分页查询客户出入库列表
  selectYgnInoutRecordByPage: '/ygsjzs/ygnInoutRecord/selectYgnInoutRecordByPage',
  // 修改出入库车辆信息表
  updateYgnInoutVehicle: '/ygsjzs/ygnInoutVehicle/updateYgnInoutVehicle',
  // 新增出库如车辆信息
  insertYgnInoutVehicle: '/ygsjzs/ygnInoutVehicle/insertYgnInoutVehicle',
  // 导出出入库详情
  txYgnInoutVehiclePdf: '/ygsjzs/ygnInoutRecord/txYgnInoutVehiclePdf',
  // 导出车辆
  txYgnInoutVehiclePdf2: '/ygsjzs/ygnInoutVehicle/txYgnInoutVehiclePdf',
  // 物理删除出入库车辆信息表
  deleteDataYgnInoutVehicle: '/ygsjzs/ygnInoutVehicle/deleteDataYgnInoutVehicle',
  // 查询出入库车辆信息表详情
  selectYgnInoutVehicleByInoutVehicleId: '/ygsjzs/ygnInoutVehicle/selectYgnInoutVehicleByInoutVehicleId',
  // 导入车辆信息
  selectByXlsData: '/ygsjzs/ygnInoutRecord/selectByXlsData',
  // 完成储运订单
  endYgnInoutRecord: '/ygsjzs/ygnInoutRecord/endYgnInoutRecord',
  // 新增调拨单(新)
  insertYgnInoutRecordToPdf: '/ygsjzs/ygnInoutRecord/insertYgnInoutRecordToPdf',
  // 审核调拨单(新)
  approveYgnInoutRecordHz: '/ygsjzs/ygnInoutRecord/approveYgnInoutRecordHz',
  // 导出货转单
  txYgnInoutVehiclePdfHz: '/ygsjzs/ygnInoutRecord/txYgnInoutVehiclePdfHz',
  // 发送车辆短信通知
  sendYgnInoutVehicleSms: '/ygsjzs/ygnInoutVehicle/sendYgnInoutVehicleSms',
  // 发送车辆短信通知
  exportYgnInoutRecord: '/ygsjzs/ygnInoutRecord/exportYgnInoutRecord'
}
